// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menuButton-container hr{margin:7px 0}`, "",{"version":3,"sources":["/app/src/components/menuButton/menuButton.scss"],"names":[],"mappings":"AAMI,yBACE,YAAA","sourcesContent":["$prefix: menuButton-;\n\n.#{$prefix} {\n\n  &container {\n\n    hr {\n      margin: 7px 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
